module.exports = __webpack_public_path__ + "static/media/data_light_logo.68b5f378.svg";